import React from "react";
import "../../styles/components/eagleView.scss"
import TaskRequests from "./taskRequests";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';


export class DeskNotifView extends React.Component {
    state = {}

    showRequests = () => {
        this.setState({ showConfirmation: !this.state.showConfirmation })
    }


    render() {


        return (

            <div className="">
                <div class="responsive-banner ">
                    <div class=" py-3 w-100">

                        {/* <svg class="cirle-a" height="160" width="160">
                        <circle cx="80" cy="80" r="80" />

                    </svg>
                    <div className="moving-circle-a"></div>
                    <svg class="cirle-b" height="60" width="60">
                        <circle cx="30" cy="30" r="30" />

                    </svg>
                    <div className="moving-circle-b"></div>

                    <svg class="cirle-c" height="600" width="600">
                        <circle cx="300" cy="300" r="300" />

                    </svg>

                    <svg class="cirle-d" height="60" width="60">
                        <circle cx="30" cy="30" r="30" />
                    </svg> */}

                        <button onClick={() => this.showRequests()} class=" flexcb w-100 px-3" style={{}}>
                            <div className="flexc">
                                <img className="invert" src="/assets/icons/useful/bell.png" width="20px" alt="" />
                                <p className="mx-2 white text-small">{this.props.title}</p>
                            </div>
                            <p class="request-num">{this.props.requestNumbers}</p>

                        </button>
                        {/* <div className="moving-circle-d"></div>
                    <div className="moving-circle-c"></div>
                    <div className="moving-circle-e"></div> */}

                    </div>



                    {this.state.showConfirmation && (
                        <div className="confirmation-task">
                            <div className="sidePanel h-100 scroll-no-scrollbar" style={{ width: '90%', maxWidth: '400px' }}>
                                {this.props.inbox.pendingTask?.map((prop, index) => {
                                    console.log('this.props.inbox.pendingTask', this.props.inbox.pendingTask)
                                    return (
                                        <div className="" style={{ width: '90%', maxWidth: '400px' }} >
                                            <div className='sidePanel-content h-100 blur-back bg-white py-1' >
                                                <TaskRequests approveTask={this.props.approveTask} width={this.props.width} item={prop} />
                                                {/* <button className={"close-hide sideHandler blur-back flexcc "} onClick={() => this.setState({ showConfirmation: false })}>
                                                    <img src="/images/next-2.png" width="20px" alt="" />
                                                </button> */}
                                            </div>
                                        </div>
                                        //  {/* <Confirmation approveTask={this.props.approveTask} width={this.props.width} item={prop} /> */}
                                    )
                                })}
                            </div>
                        </div>
                    )}

                </div>
            </div>

        )
    }
}




const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeskNotifView);